import { render } from "./ReportDiagnostics.vue?vue&type=template&id=68c80350"
import script from "./ReportDiagnostics.vue?vue&type=script&lang=js"
export * from "./ReportDiagnostics.vue?vue&type=script&lang=js"

import exportComponent from "/Volumes/Whisper/Development/projects/sid/ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QChip from 'quasar/src/components/chip/QChip.js';
import QBanner from 'quasar/src/components/banner/QBanner.js';
import QList from 'quasar/src/components/item/QList.js';
import QExpansionItem from 'quasar/src/components/expansion-item/QExpansionItem.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../../../../../../../Volumes/Whisper/Development/projects/sid/ui/node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QChip,QBanner,QList,QExpansionItem,QBtn});
